/* eslint-disable implicit-arrow-linebreak */
import * as React from 'react';
import { createStyles, Theme, makeStyles } from '@material-ui/core/styles';
import update from 'immutability-helper';
import { ReactComponent as CloseIcon } from '../../../assets/svg/icons/close-icon.svg';

const myStyles = makeStyles((theme: Theme) => {
    return createStyles({
        root: {
            display: 'flex',
            border: 'none',
            flexWrap: 'wrap',
            padding: theme.spacing(0.5)
        }
    });
});

const LozengeFilterOptions = ({ filters, onUpdate }: LozengeFilterOptionsProps) => {
    const classes = myStyles(0);

    const onDelete = (filterIndex: number, index: number) => {
        const updateItems = filters[filterIndex].items;
        const newUpdatedItems = update(updateItems, { [index]: { checked: { $set: false } } });
        const newState = update(filters, { [filterIndex]: { items: { $set: newUpdatedItems } } });
        onUpdate(newState);
    };

    return (
        <>
            {filters.filter((filterItem: FilterObjects) => filterItem.items.some(item => item.checked === true)).length > 0 && (
                <div className={classes.root}>
                    {filters.map((filterItem, filterIndex) => {
                        return filterItem.items.map((item, index) => {
                            return (
                                item.checked && (
                                    <div className="lozenge-filter-options" key={item.name}>
                                        <div className="lozenge-filter-options__text"> {item.name} </div>
                                        <div className="lozenge-filter-options__close">
                                            <CloseIcon onClick={() => onDelete(filterIndex, index)} />
                                        </div>
                                    </div>
                                )
                            );
                        });
                    })}
                </div>
            )}
        </>
    );
};

export default LozengeFilterOptions;
